:host {
  display: inline-block;
  width: 22px;
  height: 22px;
}

svg {
  max-width: 100%;
  height: auto;
  vertical-align: middle;
  fill: currentColor;
  width: inherit;
  height: inherit;
}